import { Modal } from './Modal';
import { ReportBugButton } from './ReportBugButton';
import { generateBugReportTemplate } from '~/utils/templates';
import { ProUpgradeModal } from './ProUpgradeModal';
interface ErrorModalProps {
  isOpen: boolean;
  onClose: () => void;
  onRetry: () => void;
  title: string;
  message: string;
  isTLE?: boolean;
}

export const ErrorModal = ({ isOpen, onClose, onRetry, title, message, isTLE = false }: ErrorModalProps) => {
  if (!isOpen) {
    return null;
  }

  const framework = localStorage.getItem('selectionframework');
  const frameworkLabels = framework?.toLowerCase().split('_');
  const bugLabels = ['bug', ...(frameworkLabels || [])];
  console.log('message >>', message);

  const bugReportBody = generateBugReportTemplate(message);

  return !isTLE ? (
    <Modal isOpen={isOpen} onClose={onClose}>
      <div className="fixed inset-0 bg-black/70 backdrop-blur-sm z-50" />
      <div className="fixed top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 z-51 w-full px-4 max-w-[480px]">
        <div className="bg-[#1a0f0f] rounded-xl border-black relative w-full overflow-hidden">
          <button
            onClick={onClose}
            className="absolute top-2 right-2 p-2 text-red-400 bg-transparent border-none rounded-md hover:bg-red-900/20 transition-colors z-10"
          >
            <div className="i-ph:x w-4 h-4 bg-white" />
          </button>

          <div className="p-10">
            <div className="bg-[#2d1515] rounded-lg border border-red-900/50 p-4 mb-4">
              <h2 className="text-red-500 text-sm font-medium flex items-center gap-2">
                <span>Error: {title}</span>
              </h2>
              <p className="text-red-400/80 text-sm mt-2">{message}</p>
            </div>

            <div className="flex flex-col gap-3">
              <button
                onClick={onRetry}
                className="flex items-center justify-center w-full px-4 py-3 bg-[#1f1f1f] hover:bg-[#2a2a2a] rounded-lg text-gray-300 text-sm font-medium transition-colors"
              >
                Start a new chat
              </button>
              <div className="flex items-center cursor-pointer rounded-lg justify-center gap-3 w-full text-left px-4 py-2.5 text-sm text-gray-200 bg-[#1f1f1f] hover:bg-[#2a2a2a] active:bg-gray-700/90 transition-colors duration-150 ">
                <div className="i-ph:bug text-lg bg-white" />
                <ReportBugButton title={`Bug Report: ${title}`} body={bugReportBody} labels={bugLabels} />
              </div>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  ) : (
    <ProUpgradeModal isOpen={isOpen} onClose={onClose} description={message} />
  );
};
